{
  "dismiss": "Пропустить"
}
